/*jshint browser: true */
/*global require: false */

require(['jquery'], function ($) {
    'use strict';

    // FIXED SECONDARY MENU
    $(function () {
        var headerPos = $('.menu-microsite').offset().top;

        $(window).scroll(function () {
            if ($(window).scrollTop() > headerPos) {
                $('.menu-microsite').css({ position: 'fixed', top: '0px' });

            } else {
                $('.menu-microsite').css({ position: 'relative', top: 'auto' });
            }
        });
    });
    
    // CONTACT SECTION SHOW HIDE

    $('.box-expand').click(function () {
        $('.box-expand-contents').slideToggle();

        $('.box-expand span').toggleClass('icon-arrow-up');
    });
     
    // MENU FUNCTIONALITY
     
    const dropdownclass = document.getElementsByClassName("dropbtn");
    const anchor = document.getElementById("js-dropdown");
    if (anchor)
    {
        anchor.setAttribute("aria-expanded", "false");
    }
    for (let i = 0; i < dropdownclass.length; i++) {
        dropdownclass[i].setAttribute("tabindex", "0");

        dropdownclass[i].addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                anchor.classList.toggle('show');

                if (anchor.classList.contains('show')) {
                    anchor.setAttribute("aria-expanded", "true");
                } else {
                    anchor.setAttribute("aria-expanded", "false");
                }
            }
        });
    }


    document.addEventListener("click", function (e) {
        if (anchor && !anchor.contains(e.target) && !e.target.classList.contains("dropbtn")) {
            if (anchor.classList.contains("show")) {
                anchor.classList.remove("show");
                anchor.setAttribute("aria-expanded", "false");
            }
        }
    });

    const dropdownclass1 = document.getElementsByClassName("dropbtn1");
    const jsdropdown = document.getElementsByClassName("$('#js-dropdown1')");
    for (let i = 0; i < dropdownclass1.length; i++) {
        dropdownclass1[i].setAttribute("tabindex", "0");

        dropdownclass1[i].addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                $('#js-dropdown1').toggleClass('show');

                if (jsdropdown.classList.contains('show')) {
                    jsdropdown.setAttribute("aria-expanded", "true");
                }
                else {
                    jsdropdown.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    $('.dropbtn').click(function () {
        $('#js-dropdown').toggleClass('show');
        if (anchor.classList.contains('show')) {
            anchor.setAttribute("aria-expanded", "true");
        }
        else {
            anchor.setAttribute('aria-expanded', 'false');
        }
    });

    $('.dropbtn1').click(function () {
        $('#js-dropdown1').toggleClass('show');
        if (anchor.classList.contains('show')) {
            anchor.setAttribute("aria-expanded", "true");
        }
        else {
            anchor.setAttribute('aria-expanded', 'false');
        }
    });
   

    $('.hamburger').click(function () {
        $('.menu').toggleClass('responsive');
    });

    $(window).click(function (e) {
        if (!e.target.matches('.dropbtn')) {
            $('#js-dropdown').removeClass('show');

        }
        if (!e.target.matches('.dropbtn1')) {
            $('#js-dropdown1').removeClass('show');

        }
    });
});
define("microsite", function(){});

